import styles from "../member.module.scss";
import type { SocialKind, SocialLink } from "../_data/members";

const LABELS: Record<SocialKind, string> = {
  x: "X",
  note: "note",
  facebook: "Facebook",
};

// 外部アイコンライブラリを足さずに済むよう、3種類ぶんだけ直接持つ
const ICONS: Record<SocialKind, React.ReactNode> = {
  x: (
    <path d="M18.9 2H22l-7.2 8.3L23.3 22h-6.6l-5.2-6.8L5.5 22H2.4l7.7-8.8L1.9 2h6.8l4.7 6.2L18.9 2Zm-1.1 18h1.7L7.3 3.7H5.5L17.8 20Z" />
  ),
  // note はロゴが実質「n」の字形。書類アイコンだと note と認識されないため字形で出す
  note: (
    <path d="M6.2 7.6h2.9v1.6c.9-1.3 2.3-1.9 3.9-1.9 2.9 0 4.8 2 4.8 5.1v8h-3v-7.5c0-1.8-1-2.9-2.6-2.9-1.7 0-3.1 1.3-3.1 3.2v7.2h-2.9V7.6Z" />
  ),
  facebook: (
    <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.52 1.49-3.91 3.77-3.91 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.78-1.63 1.57v1.89h2.78l-.45 2.91h-2.33V22c4.78-.76 8.44-4.92 8.44-9.94Z" />
  ),
};

function Icon({ kind }: { kind: SocialKind }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      {ICONS[kind]}
    </svg>
  );
}

export default function SocialLinks({ socials }: { socials?: SocialLink[] }) {
  if (!socials || socials.length === 0) return null;

  return (
    <ul className={styles.socialList}>
      {socials.map(({ kind, url }) => (
        <li key={kind}>
          {url ? (
            <a
              href={url}
              className={`${styles.socialLink} hover-target`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={LABELS[kind]}
            >
              <Icon kind={kind} />
            </a>
          ) : (
            // 押しても何も起きない要素にならないよう、リンクにはしない
            <span
              className={`${styles.socialLink} ${styles.socialPending}`}
              aria-disabled="true"
              aria-label={`${LABELS[kind]}（準備中）`}
              title="準備中"
            >
              <Icon kind={kind} />
            </span>
          )}
        </li>
      ))}
    </ul>
  );
}
